import { ReportsState } from '../../types';

export const resetReportGuid = (state: ReportsState) => {
  state.report.guid = null;
};
